<template>
  <div class="packagedialog">
    <myMask></myMask>
    <!-- <div class="packagedialog-box flex flex--col flex--middle">
      <div @click.stop="closeModal">
        <i class="icon-close"></i>
      </div>
      <div class="packagedialog-box--title">爆单资料包</div>
      <div class="packagedialog-box--code">
        <img src="../../assets/toutiao/package_code.png" />
      </div>
      <div class="packagedialog-box--text">
        <p>新手如何通过壹心理<span>日赚十万</span></p>
        <p>最全资料包请添加微信领取</p>
      </div>
      <div class="packagedialog-box--tis">
        微信：yixinlidudu
        <span ref="copyText" :data-clipboard-text="'yixinlidudu'">复制</span>
      </div>
    </div> -->
    <div class="warning__popup">
      <div @click.stop="closeModal">
        <i class="icon-close"></i>
      </div>
      <p class="warnint__title">
        ！重要通知：
      </p>
      <p>
        经抖音审查发现，现有推广者（微信名：赵莉 420497011344961536205）被抖音直接查出发布令人不适的视频，下令整改，现经过讨论决定，冻结该推广者收益，并告知其他平台注意该用户。
      </p>
      <p>
        1. 为维护抖音环境，欢迎大家举报令人不适的视频，举报有奖，莫让一人行为全网买单
      </p>
      <p>
        2. 现正在全面检查中，除了人工排查外，后台系统也会对视频内容进行筛查，请大家自查抖音视频，如有不适内容立即隐藏。若被查到，将直接冻结收益，后果自负。
      </p>
      <p>
        3. 从现在起，不允许轻易解绑账号，请大家对自己的账号负责。
      </p>
      <p>
        4. 壹心理坚决配合抖音整改活动，也多次发提醒大家不要发布此类视频，望周知！
      </p>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import myMask from '../common/mask'
export default {
  name: 'packageDialog',
  components: {
    myMask
  },
  data() {
    return {}
  },
  watch: {},
  props: {},
  computed: {},
  mounted() {
    // this.$nextTick(() => {
    //   this.initTextBtn()
    // })
  },
  methods: {
    closeModal() {
      this.$emit('_closeModal')
    },
    initTextBtn(id, title) {
      console.log('点击复制')
      let clipboard = new Clipboard(this.$refs.copyText)
      clipboard.on('success', e => {
        e.clearSelection()
        this.setTOASTTEXT({ str: '微信号已复制' })
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/function';
.packagedialog {
  .packagedialog-box {
    width: topx(556rem);
    height: topx(687rem);
    position: fixed;
    top: 50%;
    left: 50%;
    margin-left: topx(-277.5rem);
    margin-top: topx(-345.5rem);
    background: linear-gradient(
      325deg,
      rgba(255, 84, 110, 1) 0%,
      rgba(255, 157, 141, 1) 100%
    );
    border-radius: topx(26rem);
    color: #fff;
    z-index: 11;
    .icon-close {
      position: absolute;
      display: block;
      top: topx(-66rem);
      right: 0;
      width: topx(44rem);
      height: topx(44rem);
      background: url('../../assets/btn_close.png') center no-repeat;
      background-size: topx(44rem);
    }
    &--title {
      margin-top: topx(40rem);
      font-size: topx(38rem);
      line-height: topx(32rem);
      font-weight: bold;
    }
    &--code {
      width: topx(260rem);
      height: topx(260rem);
      border-radius: topx(26rem);
      margin-top: topx(40rem);
      background: url('../../assets/toutiao/package_code_bg.png') no-repeat
        center;
      background-size: 100% 100%;
      padding: topx(20rem);
      img {
        width: 100%;
        height: auto;
      }
    }
    &--text {
      font-size: topx(32rem);
      color: #fff;
      line-height: topx(45rem);
      margin-top: topx(40rem);
      text-align: center;
      p {
        margin-bottom: topx(10rem);
      }
      span {
        color: #ffdd2b;
      }
    }
    &--tis {
      font-size: topx(32rem);
      color: #fff;
      line-height: topx(45rem);
      margin-top: topx(40rem);
      span {
        font-size: topx(24rem);
        margin-left: topx(20rem);
        border: topx(2rem) solid #ddd;
        padding: topx(8rem) topx(20rem);
        border-radius: topx(8rem);
      }
    }
  }
}

.warning__popup {
  padding: topx(30rem) topx(40rem);
  font-size: topx(28rem);
  line-height: topx(32rem);
  width: topx(556rem);
  height: topx(707rem);
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: topx(-277.5rem);
  margin-top: topx(-355.5rem);
  background: #fff;
  border-radius: topx(26rem);
  color: #000;
  z-index: 11;
  box-sizing: border-box;
  word-break: break-all;

  p {
    margin-bottom: topx(5rem);
    text-align: justify;
  }

  .icon-close {
    position: absolute;
    display: block;
    top: topx(-66rem);
    right: 0;
    width: topx(44rem);
    height: topx(44rem);
    background: url('../../assets/btn_close.png') center no-repeat;
    background-size: topx(44rem);
  }

  .warnint__title {
    margin-bottom: topx(10rem);
    font-size: topx(32rem);
    line-height: topx(32rem);
    font-weight: bold;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/toutiao/packageDialog.vue